var map = {
	"./bankwire-mob.svg": 50659,
	"./bankwire.png": 26684,
	"./bankwire.svg": 69741,
	"./bitcoin-mob.svg": 53413,
	"./bitcoin.png": 55813,
	"./bitcoin.svg": 74544,
	"./cup.png": 4043,
	"./fasapay.png": 69047,
	"./ideal.png": 27058,
	"./instantbanktransfer.png": 98102,
	"./jeton-wallet.png": 52699,
	"./jeton.png": 7211,
	"./koalapay.png": 49301,
	"./lydiax-mob.svg": 15069,
	"./lydiax.png": 57523,
	"./lydiax.svg": 70422,
	"./my-pay.png": 68663,
	"./neteller.png": 3682,
	"./neteller.svg": 8940,
	"./paykasa.png": 69094,
	"./powercash.png": 42412,
	"./safecharge.png": 97222,
	"./skrill.png": 77907,
	"./skrill.svg": 50559,
	"./sofort.png": 33079,
	"./trustly.png": 11312,
	"./visa-mastercard-powercash.svg": 34700,
	"./visa-mastercard-safecharge.svg": 27095,
	"./visa-mastercard.png": 27199,
	"./visa-mastercard.svg": 99779,
	"./vload-backup.png": 54127,
	"./vload-mob.svg": 5449,
	"./vload.png": 27513,
	"./vload.svg": 45959
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94060;